export const MY_RAIL_GPT = 'MyRailBuddy';
export const POWERED_BY_GPT = 'powered by chatGPT';
export const YOU_CAN_ASK = 'You can ask "What is my PNR status?"';
export const GPT_URL = 'https://myra.makemytrip.com/chatBot?lob=TRAINS&project=trains_chatbot&view=LANDING';
